import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9232eb0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-select-top el-card" }
const _hoisted_2 = { class: "service-list-label" }
const _hoisted_3 = { class: "service-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TerminalAuth = _resolveComponent("TerminalAuth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_TerminalAuth, {
    ref: "terminalSelectNode",
    "model-value": _ctx.modelValue,
    title: _ctx.$t('terminalAuth.batchConfigTitle'),
    "terminal-api-url": "/permission_service/terminal_list",
    "permission-names": _ctx.serviceList.map(v => v.permission_name),
    "terminal-type": _ctx.terminalType,
    onClose: _ctx.handleClose
  }, {
    top: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('terminalAuth.batchSelectedServices')), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "service-item el-card",
              key: index
            }, _toDisplayString(item.display_name), 1))
          }), 128))
        ])
      ])), [
        [_directive_loading, _ctx.isLoading]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title", "permission-names", "terminal-type", "onClose"]))
}